<div
  aria-label="class-client-booking-container"
  class="flex flex-column h-full main-container"
>
  <!-- Member status tabs -->
  <nav
    class="flex-shrink-0 px-3 pt-2 pb-2 border-bottom-1 border-200 surface-0"
    aria-label="status-tabs"
    role="tablist"
  >
    <div
      class="flex flex-nowrap gap-2 overflow-x-auto pb-1"
      style="scrollbar-width: thin"
    >
      @for (status of GetMemberStatus; track status.name) {
        <button
          type="button"
          role="tab"
          class="flex-shrink-0 border-none cursor-pointer px-3 py-2 border-round-3xl text-sm font-medium transition-all transition-duration-200 white-space-nowrap"
          [ngClass]="
            isMemberStatusTabSelected(status)
              ? 'bg-primary text-white shadow-2'
              : 'surface-100 text-700 hover:surface-200 hover:shadow-1'
          "
          [attr.aria-selected]="isMemberStatusTabSelected(status)"
          (click)="ToggleButton(status)"
          [attr.aria-label]="'status-tab-' + status.name"
        >
          {{ 'SCHEDULE.VIEWCLASS.' + status.name | translate }}
          <span
            class="ml-2 px-2 py-0 border-round-3xl text-xs font-bold"
            [ngClass]="
              isMemberStatusTabSelected(status)
                ? 'bg-primary-700 text-white'
                : 'surface-200 text-800'
            "
            >{{ status.count }}</span
          >
        </button>
      }
    </div>
  </nav>

  @if (classObj()) {
    <section
      class="px-3 py-2 md:py-3 flex-shrink-0 border-bottom-1 border-200 surface-50 w-full"
      aria-label="class-booking-window-status"
    >
      <!-- Mobile: compact label rows -->
      <ul
        class="flex flex-column gap-2 list-none p-0 m-0 md:hidden"
        aria-label="class-booking-window-status-mobile"
      >
        <li
          class="flex align-items-center justify-content-between gap-2 min-w-0"
          aria-label="class-early-cancel-status-mobile"
        >
          <span class="text-xs text-700 font-medium line-height-3 flex-1 min-w-0">{{
            'SCHEDULE.VIEWCLASS.EARLY_CANCEL_WINDOW' | translate
          }}</span>
          <p-tag
            [severity]="earlyCancelWindowOpen ? 'success' : 'secondary'"
            styleClass="text-xs flex-shrink-0"
            [value]="earlyCancelWindowStatusKey | translate"
          />
        </li>
        <li
          class="flex align-items-center justify-content-between gap-2 min-w-0"
          aria-label="class-waitlist-roster-status-mobile"
        >
          <span class="text-xs text-700 font-medium line-height-3 flex-1 min-w-0">{{
            'SCHEDULE.VIEWCLASS.WAITLIST_ROSTER' | translate
          }}</span>
          <p-tag
            [severity]="waitlistRosterOpen ? 'success' : 'secondary'"
            styleClass="text-xs flex-shrink-0"
            [value]="waitlistRosterStatusKey | translate"
          />
        </li>
        <li
          class="flex align-items-start justify-content-between gap-2 min-w-0"
          aria-label="class-b2c-booking-status-mobile"
        >
          <span class="text-xs text-700 font-medium line-height-3 flex-1 min-w-0">{{
            'SCHEDULE.VIEWCLASS.B2C_BOOKING_STATUS' | translate
          }}</span>
          <p-tag
            [severity]="b2cBookingTagSeverity"
            styleClass="text-xs flex-shrink-0 white-space-normal text-right"
            [value]="b2cBookingStatusKey | translate"
          />
        </li>
      </ul>

      <!-- Desktop: status cards in a single row -->
      <div
        class="hidden md:block w-full"
        aria-label="class-booking-window-status-desktop"
      >
        <div class="flex flex-nowrap gap-2 w-full">
        <article
          class="flex-1 min-w-0 flex flex-column gap-2 p-3 border-1 border-200 border-round-lg bg-white shadow-1"
          aria-label="class-early-cancel-status"
        >
          <div class="flex align-items-center gap-2 min-w-0">
            <span
              class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-primary-50 text-primary flex-shrink-0"
            >
              <i class="fa fa-clock text-sm" aria-hidden="true"></i>
            </span>
            <span
              class="text-xs text-700 font-medium line-height-3 overflow-hidden text-overflow-ellipsis white-space-nowrap"
              >{{
              'SCHEDULE.VIEWCLASS.EARLY_CANCEL_WINDOW' | translate
            }}</span>
          </div>
          <p-tag
            [severity]="earlyCancelWindowOpen ? 'success' : 'secondary'"
            styleClass="text-xs w-full"
            [value]="earlyCancelWindowStatusKey | translate"
          />
        </article>

        <article
          class="flex-1 min-w-0 flex flex-column gap-2 p-3 border-1 border-200 border-round-lg bg-white shadow-1"
          aria-label="class-waitlist-roster-status"
        >
          <div class="flex align-items-center gap-2 min-w-0">
            <span
              class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-primary-50 text-primary flex-shrink-0"
            >
              <i class="fa fa-list-ul text-sm" aria-hidden="true"></i>
            </span>
            <span
              class="text-xs text-700 font-medium line-height-3 overflow-hidden text-overflow-ellipsis white-space-nowrap"
              >{{
              'SCHEDULE.VIEWCLASS.WAITLIST_ROSTER' | translate
            }}</span>
          </div>
          <p-tag
            [severity]="waitlistRosterOpen ? 'success' : 'secondary'"
            styleClass="text-xs w-full"
            [value]="waitlistRosterStatusKey | translate"
          />
        </article>

        <article
          class="flex-1 min-w-0 flex flex-column gap-2 p-3 border-1 border-200 border-round-lg bg-white shadow-1"
          aria-label="class-b2c-booking-status"
        >
          <div class="flex align-items-center gap-2 min-w-0">
            <span
              class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-primary-50 text-primary flex-shrink-0"
            >
              <i class="fa fa-mobile-alt text-sm" aria-hidden="true"></i>
            </span>
            <span
              class="text-xs text-700 font-medium line-height-3 overflow-hidden text-overflow-ellipsis white-space-nowrap"
              >{{
              'SCHEDULE.VIEWCLASS.B2C_BOOKING_STATUS' | translate
            }}</span>
          </div>
          <p-tag
            [severity]="b2cBookingTagSeverity"
            styleClass="text-xs w-full white-space-normal"
            [value]="b2cBookingStatusKey | translate"
          />
        </article>
        </div>
      </div>
    </section>
  }

  <!-- Search Box -->
  @if (showMiniSearch | async) {
    <div
      class="surface-0 p-3 md:p-4 flex-shrink-0 border-bottom-1 border-200"
      [ngClass]="isClassCompletedOrCancelled ? 'pointer-events-none opacity-60' : ''"
      aria-label="client-search-section"
    >
      <div class="relative z-2">
        @if (miniSearchV2Enabled) {
          <mini-search-v2
            class="p-input-icon-right w-full"
            [showCreateClient]="false"
            [isReadonly]="false"
            [showSelected]="false"
            [dialogTitle]="'Shared.SEARCH.MINI-SEARCH.ADD_MEMBER_TO_CLASS' | translate"
            [dialogSubtitle]="miniSearchV2DialogSubtitle()"
            (clients)="AddClient($event)"
            (createProspect)="createProspect($event)"
            aria-label="client-search-input"
          />
        } @else {
          <mini-search
            class="p-input-icon-right w-full"
            [showCreateClient]="false"
            [readonly]="false"
            [showSelected]="false"
            (clients)="AddClient($event)"
            (createProspect)="createProspect($event)"
            aria-label="client-search-input"
          />
        }
      </div>
    </div>
  }
  @if ((showMiniSearch | async) === false) {
    <div class="px-3 flex-shrink-0" aria-label="search-loading">
      <p-skeleton height="3rem" styleClass="mb-2" />
    </div>
  }
  <!-- Search Box -->

  <!-- User Detail Header -->
  <div
    class="grid grid-nogutter surface-200 text-700 uppercase font-semibold text-xs border-y-1 border-300 flex-shrink-0 px-3 py-3 align-items-center w-full"
    aria-label="user-details-header"
  >
    <div class="col-3" aria-label="client-name-header">
      {{ 'SCHEDULE.VIEWCLASS.CLIENT_NAME' | translate }}
    </div>
    <div class="col-2" aria-label="indicators-header">
      {{ 'SCHEDULE.VIEWCLASS.INDICATORS' | translate }}
    </div>
    <div class="col-2" aria-label="payment-status-header">
      {{ 'SCHEDULE.VIEWCLASS.PAYMENT_STATUS' | translate }}
    </div>
    <div class="col-3" aria-label="subscription-header">
      {{ 'SCHEDULE.VIEWCLASS.SUBSCRIPTION' | translate }}
    </div>
    <div class="col-2 text-right" aria-label="actions-header">
      {{ 'SCHEDULE.VIEWCLASS.ACTIONS' | translate }}
    </div>
  </div>
  <!-- User Detail Header -->

  <div class="flex-1 relative overflow-hidden min-h-0">
    @if (showLoader$ | async) {
      <p-scrollPanel styleClass="w-full h-full" aria-label="loading-panel">
        <div
          class="left-0 top-0 z-5 flex align-items-center surface-0 justify-content-center w-full h-full"
        >
          <p-progressSpinner aria-label="loading-spinner" />
        </div>
      </p-scrollPanel>
    }
    <!-- Scroll -->
    @if (getClients && getClients.length > 0) {
      <p-scrollPanel
        styleClass="w-full h-full"
        aria-label="clients-list"
        [style]="{ height: '100%', 'max-height': '100%' }"
      >
        <ul
          class="list-none my-0 ml-0 xl:-mr-2 px-0 md:px-0 pt-0 pb-3 text-xs md:text-sm"
        >
          @for (client of getClients; track client.class_booking_client_Id) {
            <li
              class="grid grid-nogutter align-items-center mb-2 md:mb-0 mx-2 md:mx-0 border-1 md:border-bottom-1 md:border-top-none md:border-left-none md:border-right-none border-200 border-round md:border-round-none bg-white md:bg-transparent shadow-2 md:shadow-none hover:surface-50 transition-all transition-duration-200 px-3 py-2 md:py-3"
              [attr.aria-label]="
                'client-item-' + client.class_booking_client_Id
              "
            >
              <!-- Client Name -->
              <div
                class="col-3 flex align-items-center min-w-0"
                aria-label="client-info"
              >
                @let memberRow = mapClientForMemberDisplay(client);
                <p-popover
                  #clientMemberPopover
                  styleClass="overflow-hidden"
                  appendTo="body"
                  [dismissable]="true"
                >
                  <ng-template #content>
                    <div
                      class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
                    >
                      <div class="w-10rem line-height-1 mr-2">
                        <div class="text-sm font-medium text-800">
                          {{ memberRow.full_name }}
                        </div>
                        <div class="text-xs text-600 mt-1">{{ memberRow.id }}</div>
                      </div>
                      <div [innerHTML]="clientMemberStatus(memberRow)"></div>
                    </div>
                    <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs">
                      <div class="flex align-items-center mb-2">
                        <i class="fa fa-phone mr-2 text-500"></i>
                        {{ memberRow.mobile_country_code }}{{ memberRow.mobile_number }}
                      </div>
                      <div class="flex align-items-center mb-1">
                        <i class="fa fa-envelope font-light mr-2 text-500"></i>
                        @if (memberRow.email_id) {
                          <span class="break-word">
                            {{
                              memberRow.email_id?.toString().length > 20
                                ? (memberRow.email_id | slice: 0 : 20) + '...'
                                : memberRow.email_id
                            }}
                          </span>
                        } @else {
                          <span>NA</span>
                        }
                      </div>
                    </div>
                  </ng-template>
                </p-popover>
                <div class="flex align-items-center justify-content-between w-full">
                  <span
                    class="cursor-pointer flex align-items-center"
                    (mouseenter)="clientMemberPopover.show($event)"
                    (mouseleave)="clientMemberPopover.hide()"
                    (click)="openClientProfile(memberRow)"
                    [attr.aria-label]="
                      'client-name-cell-' + client.class_booking_client_Id
                    "
                  >
                    @if (!memberRow.image) {
                      <p-avatar
                        [label]="memberRow.full_name | titlecase | shortName"
                        shape="circle"
                      />
                    } @else {
                      <p-avatar [image]="memberRow.image" shape="circle" />
                    }
                    <strong class="ml-2 text-primary">
                      {{
                        memberRow.full_name?.toString().length > 20
                          ? (memberRow.full_name | slice: 0 : 20) + '...'
                          : memberRow.full_name
                      }}
                    </strong>
                  </span>
                  <!-- <div class="flex align-items-center justify-content-end text-sm ml-5">
                    @if (memberRow.client_status === 'Client') {
                      <i class="fa fa-user text-600 mr-2"></i>
                    }
                    <span>{{ getClientType(memberRow) | titlecase }}</span>
                  </div> -->
                </div>
              </div>

              <!-- Indicators -->
              <div
                class="col-2 flex align-items-center flex-wrap gap-1 min-w-0"
                [attr.aria-label]="
                  'client-booking-indicators-' + client.class_booking_client_Id
                "
              >
                @if (client.class_booking_is_first_time_class) {
                  <p-tag
                    severity="info"
                    styleClass="text-xxs"
                    [value]="'SCHEDULE.VIEWCLASS.FIRST_TIME' | translate"
                    [attr.aria-label]="
                      'first-time-badge-' + client.class_booking_client_Id
                    "
                  />
                }
                @if (isTrialBooking(client)) {
                  <p-tag
                    severity="info"
                    styleClass="text-xxs"
                    [value]="'CLIENT_BOOKING.V2.TRIAL' | translate"
                    [attr.aria-label]="
                      'client-trial-badge-' + client.class_booking_client_Id
                    "
                  />
                }
                @if (trackModeLabel(client)) {
                  <p-tag
                    severity="secondary"
                    styleClass="text-xxs"
                    [value]="trackModeLabel(client) | translate"
                    [attr.aria-label]="
                      'client-track-mode-badge-' +
                      client.class_booking_client_Id
                    "
                  />
                }
              </div>

              <!-- Payment Status -->
              <div
                class="col-2 flex align-items-center gap-2 flex-wrap min-w-0"
                aria-label="payment-status"
              >
                @if (!client.class_booking_is_payment_required) {
                  <div
                    class="flex align-items-center gap-2 flex-shrink-0"
                    [attr.aria-label]="
                      'payment-status-no-dues-' + client.class_booking_client_Id
                    "
                  >
                    <span
                      class="w-1rem h-1rem border-circle bg-green-600 flex-shrink-0"
                      aria-hidden="true"
                    ></span>
                    <span
                      class="text-xs font-medium text-green-700 white-space-nowrap line-height-1"
                      aria-label="no-dues-text"
                      >{{ 'SCHEDULE.VIEWCLASS.NO_DUES' | translate }}</span
                    >
                  </div>
                }
                @if (client.class_booking_is_payment_required) {
                  <div
                    class="flex align-items-center gap-2 flex-shrink-0"
                    [attr.aria-label]="
                      'payment-status-pending-' + client.class_booking_client_Id
                    "
                  >
                    <span
                      class="w-1rem h-1rem border-circle bg-orange-500 flex-shrink-0"
                      aria-hidden="true"
                    ></span>
                    <span
                      class="text-xs font-medium text-orange-700 white-space-nowrap line-height-1"
                      aria-label="pending-pay-text"
                      >{{ 'SCHEDULE.VIEWCLASS.PENDING_PAY' | translate }}</span
                    >
                  </div>
                }
                @if (client.class_booking_cp_booking) {
                    <img
                      src="/assets/img/classpass_compact.svg"
                      alt="ClassPass booking"
                      class="w-2rem h-2rem flex-shrink-0"
                      [attr.aria-label]="
                      'classpass-booking-' + client.class_booking_client_Id
                    "
                  />
                }
                @if (client.medical_alert) {
                  <button
                    type="button"
                    (click)="GetClietMedicalDetails(client)"
                    class="flex align-items-center gap-1 cursor-pointer bg-red-50 hover:bg-red-100 px-2 py-1 border-round border-none text-red-700 text-xxs font-medium white-space-nowrap flex-shrink-0 transition-all transition-duration-150"
                    [attr.aria-label]="
                      'medical-alert-' + client.class_booking_client_Id
                    "
                  >
                    <img
                      src="/assets/img/icons/icon-medical-alert.svg"
                      alt=""
                      class="w-1rem h-1rem"
                      aria-hidden="true"
                    />
                    <span class="hidden lg:inline">{{
                      'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate
                    }}</span>
                  </button>
                }
              </div>

              <!-- Subscription -->
              <div
                [formGroup]="clientMembershipForm"
                class="col-3 min-w-0 overflow-visible"
                aria-label="subscription-section"
              >
                @if (showSubscriptionDropdown(client)) {
                  <p-select
                    [options]="client.memberships"
                    formControlName="clientMembership_{{
                      client.class_booking_client_Id
                    }}"
                    optionLabel="subscription_primary_name"
                    filterBy="subscription_primary_name"
                    styleClass="text-sm w-full"
                    placeholder="Choose Subscription"
                    appendTo="body"
                    (onChange)="ChangeMembership($event, client)"
                    aria-label="subscription-dropdown"
                  >
                    <ng-template pTemplate="selectedItem">
                      <div
                        class="text-sm white-space-nowrap text-overflow-ellipsis overflow-hidden"
                      >
                        {{
                          clientMembershipForm.get(
                            'clientMembership_' + client.class_booking_client_Id
                          )?.value.subscription_primary_name
                        }}
                        -
                        {{
                          clientMembershipForm.get(
                            'clientMembership_' + client.class_booking_client_Id
                          )?.value.service_category_primary_name
                        }}
                      </div>
                    </ng-template>
                    <ng-template let-membership pTemplate="item">
                      <div
                        class="text-sm white-space-nowrap text-overflow-ellipsis overflow-hidden max-w-15rem"
                        pTooltip="{{
                          membership.subscription_primary_name
                        }} - {{ membership.service_category_primary_name }}"
                        tooltipPosition="left"
                        tooltipStyleClass="text-xs"
                      >
                        {{ membership.subscription_primary_name }} -
                        {{ membership.service_category_primary_name }}
                      </div>
                    </ng-template>
                  </p-select>
                } @else if (hasSubscription(client) && client.selectedMembership) {
                  <span
                    class="text-sm text-700 white-space-nowrap text-overflow-ellipsis overflow-hidden block"
                    [attr.aria-label]="
                      'selected-subscription-' + client.class_booking_client_Id
                    "
                  >
                    {{
                      client.selectedMembership.subscription_primary_name ||
                        client.selectedMembership.subscription_secondary_name
                    }}
                    -
                    {{
                      client.selectedMembership.service_category_primary_name
                    }}
                  </span>
                } @else {
                  <span class="text-sm text-500"
                    [attr.aria-label]="'no-subscription-' + client.class_booking_client_Id"
                    >-</span
                  >
                }
              </div>

              <!-- Actions -->
              @if (client.class_booking_status !== 'Cancelled') {
                <div class="col-2 flex justify-content-end min-w-0" aria-label="client-actions">
                  <button
                    pButton
                    pRipple
                    type="button"
                    icon="fa fa-ellipsis-v"
                    [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
                    iconPos="right"
                    class="p-button-outlined p-button-secondary p-button-sm text-sm w-full md:w-auto hidden md:inline-flex"
                    (click)="member1.toggle($event)"
                    [attr.aria-label]="'desktop-client-actions-button-' + client.class_booking_client_Id">
                  </button>
                  <button
                    pButton
                    pRipple
                    type="button"
                    icon="fa fa-ellipsis-v"
                    class="p-button-text p-button-rounded p-button-secondary text-600 md:hidden"
                    (click)="mobileActionMenu.toggle($event)"
                    [attr.aria-label]="'mobile-client-actions-button-' + client.class_booking_client_Id"
                  ></button>
                  <p-popover
                    #member1
                    styleClass="overflow-hidden right-0 text-sm w-13rem shadow-4"
                    [attr.aria-label]="'desktop-client-actions-panel-' +client.class_booking_client_Id"
                  >
                    <ng-template #content>
                      <ul class="list-none -m-4 px-0 py-1 text-xs text-700">
                        @if (client.class_booking_is_waitlist) {
                          <li
                            class="cursor-pointer hover:bg-green-50 hover:text-green-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            (click)="MoveWaitlistToBooked(client, $event)"
                            [attr.aria-label]="'desktop-move-waitlist-to-booked-button-' + client.class_booking_client_Id"
                          >
                            <i
                              class="fa fa-arrow-up-from-bracket text-600 mr-3 w-1rem text-center"
                            ></i>
                            <span class="font-medium">{{ 'SCHEDULE.VIEWCLASS.MOVE_WAITLIST_TO_BOOKED' | translate }}</span>
                          </li>
                        }
                        @if (!client.class_booking_is_waitlist && client.class_booking_status.toLowerCase() !== 'attended') {
                          <li
                            class="cursor-pointer hover:bg-primary-50 hover:text-primary transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            (click)="MarkClientCheckedIn(client, $event)"
                            [attr.aria-label]="'desktop-check-in-button-' + client.class_booking_client_Id"
                          >
                            <i class="fa fa-sign-in text-600 mr-3 w-1rem text-center"></i>
                            <span class="font-medium">{{'SCHEDULE.VIEWCLASS.CHECK_IN' | translate }}</span>
                          </li>
                        }
                        @if (
                          !client.class_booking_is_waitlist &&
                          client.class_booking_status.toLowerCase() !== 'noshow'
                        ) {
                          <li
                            class="cursor-pointer hover:bg-orange-50 hover:text-orange-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            (click)="MarkClientNoshow(client, $event)"
                            [attr.aria-label]="'desktop-no-show-button-' + client.class_booking_client_Id"
                          >
                            <i class="fa fa-times-circle text-600 mr-3 w-1rem text-center"></i>
                            <span class="font-medium">{{'SCHEDULE.VIEWCLASS.NO_SHOW' | translate }}</span>
                          </li>
                        }
                        <li
                          class="cursor-pointer hover:bg-red-50 hover:text-red-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                          (click)="RemoveClientFromClass(client, $event)"
                          [attr.aria-label]="'desktop-remove-client-button-' + client.class_booking_client_Id"
                        >
                          <i class="fa fa-minus-circle text-600 mr-3 w-1rem text-center"></i>
                          <span class="font-medium">{{ 'SCHEDULE.VIEWCLASS.REMOVE' | translate }}</span>
                        </li>
                        @if ( client.class_booking_status.toLowerCase() === 'attended' || client.class_booking_status.toLowerCase() === 'noshow') {
                          <li
                            (click)="MarkAsCompSession(client, $event)"
                            class="cursor-pointer hover:bg-blue-50 hover:text-blue-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            [attr.aria-label]="'desktop-comp-session-button-' + client.class_booking_client_Id"
                          >
                            <i class="fa fa-calendar-times text-600 mr-3 w-1rem text-center"></i>
                            <span class="font-medium">{{'CLIENT_BOOKING.ACTIONS.COMPSESSION' | translate }}</span>
                          </li>
                        }
                      </ul>
                    </ng-template>
                  </p-popover>
                  <p-popover
                    #mobileActionMenu
                    styleClass="overflow-hidden right-0 text-sm w-13rem shadow-4"
                    [attr.aria-label]="'mobile-client-actions-panel-' + client.class_booking_client_Id "
                  >
                    <ng-template #content>
                      <ul class="list-none -m-4 px-0 py-1 text-xs text-700">
                        @if (client.class_booking_is_waitlist) {
                          <li
                            class="cursor-pointer hover:bg-green-50 hover:text-green-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            (click)="MoveWaitlistToBooked(client, $event); mobileActionMenu.hide()"
                            [attr.aria-label]="'mobile-move-waitlist-to-booked-button-' +client.class_booking_client_Id"
                          >
                            <i
                              class="fa fa-arrow-up-from-bracket text-600 mr-3 w-1rem text-center"
                            ></i>
                            <span class="font-medium">{{ 'SCHEDULE.VIEWCLASS.MOVE_WAITLIST_TO_BOOKED' | translate }}</span>
                          </li>
                        }
                        @if ( !client.class_booking_is_waitlist && client.class_booking_status.toLowerCase() !== 'attended') {
                          <li
                            class="cursor-pointer hover:bg-primary-50 hover:text-primary transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            (click)="MarkClientCheckedIn(client, $event); mobileActionMenu.hide()"
                            [attr.aria-label]="'mobile-check-in-button-' +client.class_booking_client_Id"
                          >
                            <i
                              class="fa fa-sign-in text-600 mr-3 w-1rem text-center"
                            ></i>
                            <span class="font-medium">{{
                              'SCHEDULE.VIEWCLASS.CHECK_IN' | translate
                            }}</span>
                          </li>
                        }
                        @if (
                          !client.class_booking_is_waitlist &&
                          client.class_booking_status.toLowerCase() !== 'noshow'
                        ) {
                          <li
                            class="cursor-pointer hover:bg-orange-50 hover:text-orange-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            (click)="MarkClientNoshow(client, $event);mobileActionMenu.hide()"
                            [attr.aria-label]="'mobile-no-show-button-' +client.class_booking_client_Id"
                          >
                            <i
                              class="fa fa-times-circle text-600 mr-3 w-1rem text-center"
                            ></i>
                            <span class="font-medium">{{'SCHEDULE.VIEWCLASS.NO_SHOW' | translate}}</span>
                          </li>
                        }
                        <li
                          class="cursor-pointer hover:bg-red-50 hover:text-red-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                          (click)="RemoveClientFromClass(client, $event);mobileActionMenu.hide()"
                          [attr.aria-label]="'mobile-remove-client-button-' +client.class_booking_client_Id"
                        >
                          <i
                            class="fa fa-minus-circle text-600 mr-3 w-1rem text-center"
                          ></i>
                          <span class="font-medium">{{'SCHEDULE.VIEWCLASS.REMOVE' | translate}}</span>
                        </li>
                        @if (
                          client.class_booking_status.toLowerCase() === 'attended' ||
                          client.class_booking_status.toLowerCase() === 'noshow'
                        ) {
                          <li
                            (click)="MarkAsCompSession(client, $event);mobileActionMenu.hide()"
                            class="cursor-pointer hover:bg-blue-50 hover:text-blue-700 transition-colors transition-duration-150 py-2 px-3 flex align-items-center"
                            [attr.aria-label]="'mobile-comp-session-button-' +client.class_booking_client_Id"
                          >
                            <i
                              class="fa fa-calendar-times text-600 mr-3 w-1rem text-center"
                            ></i>
                            <span class="font-medium">{{'CLIENT_BOOKING.ACTIONS.COMPSESSION' | translate}}</span>
                          </li>
                        }
                      </ul>
                    </ng-template>
                  </p-popover>
                </div>
              } @else {
                <div class="col-2" aria-label="client-actions-empty"></div>
              }
            </li>
          }
        </ul>
      </p-scrollPanel>
    } @else {
      <p-scrollPanel
        styleClass="w-full h-full"
        aria-label="no-clients-message"
        [style]="{ height: '100%', 'max-height': '100%' }"
      >
        <div
          class="flex flex-column align-items-center justify-content-center py-8 px-4"
        >
          <i class="fa fa-users text-6xl text-400 mb-4"></i>
          <p class="mb-0 text-center font-semibold text-700 text-lg">
            {{ 'SCHEDULE.VIEWCLASS.ADD_CLIENTS' | translate }}
          </p>
          <p class="text-center text-600 text-sm mt-2">
            Search and add clients to this class using the search box above
          </p>
        </div>
      </p-scrollPanel>
    }
  </div>
  <!-- End Scroll Wrapper -->
</div>

<!-- Footer -->
<div
  class="w-full bg-white shadow-4 border-top-2 border-primary fixed right-0 bottom-0 left-0 z-5 footer-actions"
  aria-label="action-buttons-footer"
>
  <!-- Mobile Toggle Button -->
  <div
    class="md:hidden flex justify-content-center py-2 border-bottom-1 border-200 cursor-pointer hover:surface-50 transition-colors transition-duration-150"
    (click)="isMobileFooterExpanded = !isMobileFooterExpanded"
    aria-label="toggle-footer-actions"
  >
    <div class="flex align-items-center gap-2">
      <span class="text-xs font-semibold text-700">Bulk Actions</span>
      <i
        class="fa text-primary transition-all transition-duration-300"
        [ngClass]="isMobileFooterExpanded ? 'fa-angle-down' : 'fa-angle-up'"
      ></i>
    </div>
  </div>

  <!-- Action Buttons -->
  <div
    class="md:flex flex-wrap gap-2 md:gap-3 justify-content-center md:justify-content-start px-3 md:px-4 md:py-3 transition-all transition-duration-300"
    [ngClass]="isMobileFooterExpanded ? 'py-3' : 'hidden'"
    aria-label="action-buttons-container"
  >
    <div
      class="w-full md:flex-1 lg:w-auto"
      [ngClass]="
        isClassCompletedOrCancelled ? 'opacity-50 pointer-events-none' : ''
      "
    >
      <button
        pButton
        pRipple
        type="button"
        class="w-full p-button-lg border-round-lg font-semibold text-sm transition-all transition-duration-200 shadow-2"
        [ngClass]="!markAllAttended ? 'p-button-outlined p-button-success' : 'p-button-success'"
        (click)="MarkAllClientsAttended(markAllAttended)"
        aria-label="mark-all-attended-button"
      >
        <i class="fa fa-user-check mr-2"></i>
        @if (!markAllAttended) {
          <span
            [innerHTML]="'SCHEDULE.VIEWCLASS.MARK_BOOKED' | translate"
          ></span>
        } @else {
          <span>{{ 'SCHEDULE.VIEWCLASS.ALL_BOOKED' | translate }}</span>
        }
      </button>
    </div>

    <div
      class="w-full md:flex-1 lg:w-auto"
      [ngClass]="
        isClassCompletedOrCancelled ? 'opacity-50 pointer-events-none' : ''
      "
    >
      <button
        pButton
        pRipple
        type="button"
        class="w-full p-button-lg border-round-lg font-semibold text-sm transition-all transition-duration-200 shadow-2"
        [ngClass]="markCompleted ? 'p-button-info' : 'p-button-outlined p-button-info'"
        (click)="MarkClassComplete(markCompleted)"
        aria-label="mark-class-complete-button"
      >
        <i class="fa fa-check-circle mr-2"></i>
        @if (!markCompleted) {
          <span
            [innerHTML]="'SCHEDULE.VIEWCLASS.MARK_COMPLETED' | translate"
          ></span>
        } @else {
          <span>{{ 'SCHEDULE.VIEWCLASS.COMPLETED' | translate }}</span>
        }
      </button>
    </div>

    <div class="w-full md:flex-1 lg:w-auto opacity-50 pointer-events-none">
      <button
        pButton
        pRipple
        type="button"
        class="w-full p-button-lg border-round-lg font-semibold text-sm transition-all transition-duration-200 shadow-2"
        [ngClass]="sendGroupMsgs ? 'p-button-secondary': 'p-button-outlined p-button-secondary'"
        (click)="sendGroupMsgs = true"
        aria-label="send-group-messages-button"
      >
        <i class="fa fa-comments mr-2"></i>
        @if (!sendGroupMsgs) {
          <span>{{ 'SCHEDULE.VIEWCLASS.SEND_GROUP_MSGS' | translate }}</span>
        } @else {
          <span>{{ 'SCHEDULE.VIEWCLASS.MSG_SENT' | translate }}</span>
        }
      </button>
    </div>
  </div>
  <!-- Footer -->
</div>

<!-- Show Add Client To Waitlist Modal -->
<p-dialog
  [visible]="showAddClientConfirmPopup"
  (onHide)="showAddClientConfirmPopup = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '470px' }"
  styleClass="no-header-modal"
  aria-label="add-client-waitlist-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="relative text-center px-4 py-5">
      <div
        class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="showAddClientConfirmPopup = false"
        aria-label="close-waitlist-dialog"
      ></div>

      <i
        class="fa fa-exclamation-triangle p-error text-7xl mt-5"
        aria-label="warning-icon"
      ></i>

      <h4
        class="text-base md:text-lg mb-2 my-5 font-bold"
        aria-label="waitlist-confirmation-message"
      >
        {{ 'SCHEDULE.VIEWCLASS.MSG.CONFIRM_WAITLIST_MSG' | translate }}
      </h4>
    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div
      class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
    >
      <button
        pButton
        pRipple
        type="button"
        [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        class="p-button-secondary p-button-text text-sm"
        (click)="showAddClientConfirmPopup = false"
        aria-label="cancel-waitlist-button"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        [label]="'SCHEDULE.VIEWCLASS.CONTINUE' | translate"
        class="p-button-danger text-sm"
        (click)="AddClientToWaitlist()"
        aria-label="confirm-waitlist-button"
      ></button>
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Show Add Client To Waitlist Modal -->

<!-- Medical ALert Modal -->
<p-dialog
  [visible]="showMedicalAlert"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [dismissableMask]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '450px' }"
  styleClass="no-header-modal"
  (onHide)="closeMedicalAlert()"
  aria-label="medical-alert-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    @if (clientMedicalDetails) {
      <!-- Header -->
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <div
          [innerHtml]="'SCHEDULE.VIEWCLASS.MEDICAL_ALERT_FOR'| translate: { name: clientMedicalDetails.full_name }"
          aria-label="medical-alert-header"
        ></div>
        <button
          type="button"
          class="p-button-text p-button-rounded p-button-plain p-0 h-auto"
          (click)="closeMedicalAlert()"
          aria-label="close-medical-alert"
        >
          <i class="fa fa-times text-xl text-600 cursor-pointer"></i>
        </button>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div
        class="p-4 surface-50"
        [innerHtml]="clientMedicalDetails?.medical_alert"
        aria-label="medical-alert-content"
      ></div>
      <!-- Content -->
    }
  </ng-template>
</p-dialog>
<!-- Medical Alert Modal -->

<!-- Comp Session -->
<p-dialog
  [visible]="showCompSessionPopup"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal overflow-visible"
  aria-label="comp-session-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="complimentoryForm" aria-label="comp-session-form">
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-base md:text-lg" aria-label="comp-session-title">
          {{ 'CLIENT_BOOKING.HEADER' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeCompSessionPopup()"
          aria-label="close-comp-session"
        ></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 text-sm p-4">
        <label for="comp-reason-input"
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="comp-reason-label"
          >{{ 'CLIENT_BOOKING.COMP_REASON' | translate }}</label
        >
        <textarea
          pInputTextarea
          class="w-full h-5rem"
          formControlName="comments"
          [placeholder]="'CLIENT_BOOKING.COMP_REASON_PLACEHOLDER' | translate"
          aria-label="comp-reason-input"
        ></textarea>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-text text-sm"
          (click)="closeCompSessionPopup()"
          aria-label="cancel-comp-session-button"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'CLIENT_BOOKING.COMP_SESSION' | translate"
          class="text-sm"
          (click)="ComplimentoryClass(complimentoryForm)"
          [loading]="isComplimentoryLoading"
          aria-label="confirm-comp-session-button"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Comp Session -->

<!-- Show Recurring Event Modal -->
<p-dialog
  [visible]="showRecurringEventUpdatePopup"
  (onHide)="addToRecurringClass(false)"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '350px' }"
  styleClass=""
  [blockScroll]="true"
  [closable]="false"
  aria-label="recurring-event-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden"
    >{{ 'SCHEDULE.VIEWAPPOINTMENT.EDIT_RECURRING_EVENT_INFO' | translate }}
  </ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <form
      [formGroup]="addToRecurringClassForm"
      aria-label="recurring-event-form"
    >
      <ul class="list-none p-0 m-0 text-sm">
        <li class="my-3 flex align-items-start">
          <p-radioButton
            name="updateEvent"
            value="thisClass"
            inputId="option1"
            formControlName="updateEvent"
            aria-label="update-this-class-option"
          />
          <label class="ml-2" for="option1">{{'SCHEDULE.VIEWAPPOINTMENT.THIS_CLASS' | translate }}</label>
        </li>
        <li class="my-3 flex align-items-start">
          <p-radioButton
            name="updateEvent"
            value="recurringClass"
            inputId="option2"
            formControlName="updateEvent"
            aria-label="update-recurring-classes-option"
          />
          <label class="ml-2" for="option2">{{
            'SCHEDULE.VIEWAPPOINTMENT.THIS_AND_FOLLOWING_CLASSES' | translate
          }}</label>
        </li>
      </ul>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      type="button"
      [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
      class="p-button-secondary p-button-text text-sm"
      [loading]="btnLoading"
      (click)="addToRecurringClass(false)"
      aria-label="cancel-recurring-event-button"
    ></button>
    <button
      pButton
      pRipple
      type="button"
      [label]="'common.BUTTONS.BUTTON-TEXT-OK' | translate"
      class="text-sm"
      [loading]="btnLoading"
      (click)="addToRecurringClass(true)"
      aria-label="confirm-recurring-event-button"
    ></button>
  </ng-template>
</p-dialog>
<!-- Show Recurring Event Modal -->

<!-- Remove client cancellation type dialog -->
<p-dialog
  [visible]="showRemoveClientCancelTypeDialog"
  (onHide)="closeRemoveClientCancelTypeDialog()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [closable]="!removeClientCancelTypeLoading"
  [closeOnEscape]="!removeClientCancelTypeLoading"
  [dismissableMask]="!removeClientCancelTypeLoading"
  [breakpoints]="{ '960px': '92vw', '640px': '100vw' }"
  [style]="{ width: '32rem', maxWidth: '100vw' }"
  styleClass="no-header-modal remove-client-cancel-dialog"
  aria-label="remove-client-cancel-type-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <div class="flex flex-column">
      <div class="px-4 pt-4 pb-3">
        <div class="flex align-items-start justify-content-between gap-2 mb-3">
          <div class="flex align-items-start gap-3 flex-1 min-w-0 text-left">
            <div
              class="flex align-items-center justify-content-center border-circle bg-red-50 text-red-500 w-3rem h-3rem flex-shrink-0"
              aria-hidden="true"
            >
              <i class="fa fa-exclamation-triangle text-2xl"></i>
            </div>
            <div class="flex-1 min-w-0">
              <h4
                class="text-base md:text-lg font-bold text-900 m-0 mb-2"
                aria-label="remove-client-cancel-type-title"
              >
                {{
                  'SCHEDULE.VIEWCLASS.MSG.LATE_CANCEL_REMOVE_TITLE' | translate
                }}
              </h4>
              <p
                class="text-sm text-600 m-0 line-height-3"
                aria-label="remove-client-cancel-type-message"
              >
                {{
                  'SCHEDULE.VIEWCLASS.MSG.LATE_CANCEL_REMOVE_CONFIRM'
                    | translate
                }}
              </p>
            </div>
          </div>

          <button
            type="button"
            class="fa fa-times text-xl text-500 border-none bg-transparent cursor-pointer flex-shrink-0 mt-1"
            [class.opacity-50]="removeClientCancelTypeLoading"
            [disabled]="removeClientCancelTypeLoading"
            (click)="closeRemoveClientCancelTypeDialog()"
            aria-label="close-remove-client-cancel-type-dialog"
          ></button>
        </div>

        @if (removeCancelDialogClient) {
          <div
            class="flex align-items-center gap-2 p-2 border-1 border-200 border-round surface-50"
            aria-label="remove-client-cancel-type-client"
          >
            <p-avatar
              [label]="removeCancelDialogClient.full_name | shortName"
              shape="circle"
              size="normal"
              aria-label="remove-client-cancel-type-avatar"
            />
            <span
              class="font-medium text-900 text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis"
            >
              {{ removeCancelDialogClient.full_name }}
            </span>
          </div>
        }
      </div>

      <div
        class="flex flex-column gap-2 px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'SCHEDULE.VIEWCLASS.MSG.REMOVE_WITHOUT_LATE_CANCEL' | translate"
          class="p-button-outlined text-sm w-full"
          [disabled]="removeClientCancelTypeLoading"
          [loading]="
            removeClientCancelTypeLoading &&
            activeRemoveCancellationType ===
              ClassBookingCancellationType.LateCancellationBypass
          "
          (click)="
            onConfirmRemoveWithCancellationType(
              ClassBookingCancellationType.LateCancellationBypass
            )
          "
          aria-label="remove-without-late-cancel-button"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'SCHEDULE.VIEWCLASS.MSG.LATE_CANCELLATION_REMOVE' | translate"
          class="p-button-danger text-sm w-full"
          [disabled]="removeClientCancelTypeLoading"
          [loading]="
            removeClientCancelTypeLoading &&
            activeRemoveCancellationType ===
              ClassBookingCancellationType.LateCancellation
          "
          (click)="
            onConfirmRemoveWithCancellationType(
              ClassBookingCancellationType.LateCancellation
            )
          "
          aria-label="late-cancellation-remove-button"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-secondary p-button-text text-sm w-full"
          [disabled]="removeClientCancelTypeLoading"
          (click)="closeRemoveClientCancelTypeDialog()"
          aria-label="cancel-remove-client-button"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
<!-- Remove client cancellation type dialog -->
